/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Magazine_Is_ReadyInputs */

const en_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Magazine is Ready!`)
};

const es_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Tu Revista está Lista!`)
};

const fr_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre Magazine est Prêt !`)
};

const de_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Magazin ist fertig!`)
};

const ja_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マガジンの準備ができました！`)
};

const zh_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的杂志已准备就绪！`)
};

const ar_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجلتك جاهزة!`)
};

const id_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majalah Anda Sudah Siap!`)
};

const it_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Tua Rivista è Pronta!`)
};

const ru_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш Журнал Готов!`)
};

const pt_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua Revista está Pronta!`)
};

const ko_your_magazine_is_ready = /** @type {(inputs: Your_Magazine_Is_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잡지가 준비되었습니다!`)
};

/**
* | output |
* | --- |
* | "Your Magazine is Ready!" |
*
* @param {Your_Magazine_Is_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_magazine_is_ready = /** @type {((inputs?: Your_Magazine_Is_ReadyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Magazine_Is_ReadyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_magazine_is_ready(inputs)
	if (locale === "es") return es_your_magazine_is_ready(inputs)
	if (locale === "fr") return fr_your_magazine_is_ready(inputs)
	if (locale === "de") return de_your_magazine_is_ready(inputs)
	if (locale === "ja") return ja_your_magazine_is_ready(inputs)
	if (locale === "zh") return zh_your_magazine_is_ready(inputs)
	if (locale === "ar") return ar_your_magazine_is_ready(inputs)
	if (locale === "id") return id_your_magazine_is_ready(inputs)
	if (locale === "it") return it_your_magazine_is_ready(inputs)
	if (locale === "ru") return ru_your_magazine_is_ready(inputs)
	if (locale === "pt") return pt_your_magazine_is_ready(inputs)
	return ko_your_magazine_is_ready(inputs)
});